export default __webpack_public_path__ + "static/media/NotoSans-Regular.eae34fa8.ttf";